import React from 'react';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import HagraristLandingPage from './components/HagraristLandingPage';

const theme = createTheme({
  direction: 'rtl',
  typography: {
    fontFamily: 'Heebo, Arial, sans-serif',
  },
  palette: {
    primary: {
      main: '#DC2626',
    },
    secondary: {
      main: '#0A0A0A',
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <HagraristLandingPage />
    </ThemeProvider>
  );
}

export default App;
